import { isForbidden } from '@/shared/api/client';
import { i18n } from '@lingui/core';
import { msg } from '@lingui/core/macro';
import { toast as sonnerToast } from 'sonner';

/**
 * Typed façade over `sonner` — the only toast API the app calls, so call sites
 * stay decoupled from the toast library. `message`/`description` are plain
 * strings (resolve Lingui `` t`…` `` before passing). The Toaster surface lives
 * in `@/shared/components/ui/sonner`.
 */
export const toast = {
  permissionDenied: () =>
    sonnerToast.error(i18n._(msg`You don't have permission to perform this action.`)),
  success: (message: string, opts?: { description?: string }) => sonnerToast.success(message, opts),
  error: (message: string, opts?: { id?: string | number; description?: string }) =>
    sonnerToast.error(message, opts),
  /** Mutation 403s are reported once by the global MutationCache. */
  mutationError: (error: unknown, message: string, opts?: { description?: string }) =>
    isForbidden(error) ? undefined : sonnerToast.error(message, opts),
  info: (message: string, opts?: { description?: string }) => sonnerToast.info(message, opts),
  dismiss: (id?: string | number) => sonnerToast.dismiss(id),
};
